import React, { Fragment } from 'react';

import { Box } from '@chargify/custom-ui-components';

import { Separator, Container } from './ComponentsPreview.styles';
import { ComponentPreview } from './types';
import ComponentsPreviewRow from './components/ComponentsPreviewRow';

type Props = {
  /**
   * Components preview configuration
   */
  rows: ComponentPreview[];
};

const ComponentsPreview = ({ rows }: Props) => (
  <Container>
    <Box paddingTop={5} paddingBottom={5} paddingLeft={6} paddingRight={6}>
      {rows.map((row, idx) => (
        <Fragment key={row.name}>
          <ComponentsPreviewRow row={row} />
          {idx !== rows.length - 1 && (
            <Separator marginTop={5} marginBottom={5} />
          )}
        </Fragment>
      ))}
    </Box>
  </Container>
);

export default ComponentsPreview;
